module.exports = __webpack_public_path__ + "static/media/Sport.97588ddc.png";